import { render, staticRenderFns } from "./BuildInfo.vue?vue&type=template&id=3abadf82&scoped=true"
import script from "./BuildInfo.vue?vue&type=script&lang=js"
export * from "./BuildInfo.vue?vue&type=script&lang=js"
import style0 from "./BuildInfo.vue?vue&type=style&index=0&id=3abadf82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abadf82",
  null
  
)

export default component.exports